import React from "react";
import { formatDateTime } from "../../utils/date";

const MetaItem = ({ label, value }) => {
    if (!value) return null;
    return (
        <span className="text-[11px] whitespace-nowrap">
            <span className="text-slate-400">{label}</span>{" "}
            <span className="font-medium text-slate-600">{value}</span>
        </span>
    );
};

const TouchCard = ({ item, first, index }) => {
    const conversions = item.conversions || [];
    const converted = conversions.length > 0;

    return (
        <div className="relative">
            {!first && <div className="absolute left-4 -top-5 h-5 w-0.5 bg-slate-200" />}

            <div
                className={`rounded-lg border bg-white p-3.5 ${
                    converted
                        ? "border-l-4 border-emerald-400 bg-emerald-50/30"
                        : first
                        ? "border-l-4 border-indigo-400 bg-indigo-50/30"
                        : "border-slate-200"
                }`}
            >
                <div className="flex items-start justify-between gap-4">
                    <div className="flex min-w-0 items-center gap-2.5">
                        <div
                            className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-bold text-white ${
                                first ? "bg-indigo-500" : "bg-slate-400"
                            }`}
                        >
                            {index + 1}
                        </div>
                        <div className="min-w-0">
                            <h4 className="truncate text-sm font-semibold text-slate-900">{item.title}</h4>
                            <div className="text-[11px] text-slate-400">{formatDateTime(item.date)}</div>
                        </div>
                    </div>

                    <div className="flex shrink-0 flex-col items-end gap-1">
                        {converted && (
                            <span className="rounded-full bg-emerald-500 px-2 py-0.5 text-[10px] font-semibold text-white">
                                {conversions.length === 1 ? "Converted" : `${conversions.length} Payments`}
                            </span>
                        )}
                        <div className="flex flex-wrap justify-end gap-x-2.5 gap-y-0.5">
                            <MetaItem label="Source:" value={item.source} />
                            <MetaItem label="Medium:" value={item.medium} />
                            <MetaItem label="Campaign:" value={item.campaign} />
                            <MetaItem label="Keyword:" value={item.term} />
                            <MetaItem label="Content:" value={item.content} />
                        </div>
                    </div>
                </div>

                {conversions.map((conversion, i) => (
                    <div key={`conversion-${i}`} className="mt-2.5 flex flex-wrap items-center justify-between gap-x-3 gap-y-1 rounded-lg bg-emerald-50 px-3 py-2">
                        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                            <MetaItem label="Gateway" value={conversion.gateway} />
                            <MetaItem label="Product" value={conversion.product} />
                            <MetaItem label="Amount" value={`$${conversion.amount}`} />
                            <MetaItem label="Status" value={conversion.status} />
                        </div>
                        <span className="text-[10px] text-emerald-600">{formatDateTime(conversion.date)}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

const AnalyticsAttributionJourney = ({ journey = [] }) => {
    if (!journey.length) return null;

    return (
        <div className="rounded-xl border border-slate-200 bg-gradient-to-br from-amber-50/30 to-white p-4">
            <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-600">Attribution Journey</h3>
            <p className="mt-0.5 text-[11px] text-slate-400">Marketing touchpoints that eventually led to conversion</p>

            <div className="mt-3.5 space-y-2.5">
                {journey.map((item, index) => (
                    <TouchCard key={index} item={item} first={index === 0} index={index} />
                ))}
            </div>
        </div>
    );
};

export default AnalyticsAttributionJourney;